import type { FC } from "react";

import ReactDOMServer from "react-dom/server";
import styled from "styled-components";

import { Favicon } from "pro-features/components/Chart/src/dataLabels/favicon/Favicon";
import {
    RegionalDomainsFavicon,
    SegmentFavicon,
} from "pro-features/components/Chart/src/dataLabels/favicon/SegmentFavicon";
import { resolveHighChartLabelProps } from "pro-features/components/Chart/src/utils";

const Container = styled.div<{ left: number; top: number; pointWidth: number }>`
    position: absolute;
    justify-content: center;
    display: flex;
    ${({ left, top, pointWidth }) => `
        width: ${pointWidth * 2}px;
        left: ${left}px;
        top: ${top}px;
    `};
`;
export enum SubIconType {
    None,
    RegionalsWorld = "regionals-world",
    ChartPie = "chart-pie",
}
interface IIconWrapper {
    columnClassName: string;
    pointWidth: number;
    isSegment: boolean;
    favicon: string;
    containerID: string;
    subIconType?: SubIconType;
}
const PADDING = 3;
const HEIGHT = 41;
const IconWrapper: FC<IIconWrapper> = (props) => {
    const { columnClassName, pointWidth, isSegment, favicon, containerID, subIconType } = props;

    const column = document.getElementsByClassName(columnClassName)[0];
    const container = document.querySelectorAll(`#${containerID} .highcharts-root`)[0];

    if (!favicon || !column || !container) {
        return null;
    }

    const { top: columnTop, left: columnLeft } = column.getBoundingClientRect();
    const { left: containerLeft, top: containerTop } = container.getBoundingClientRect();

    const horizontalGap = columnLeft - containerLeft;
    const verticalGap = columnTop - containerTop;

    const top = verticalGap - HEIGHT;
    const left = horizontalGap - pointWidth / 2 - PADDING;

    const FaviconComponent =
        isSegment || subIconType === SubIconType.ChartPie
            ? SegmentFavicon
            : subIconType === SubIconType.RegionalsWorld
              ? RegionalDomainsFavicon
              : Favicon;
    return (
        <Container
            left={left}
            top={top}
            pointWidth={pointWidth}
        >
            <FaviconComponent src={favicon} />
        </Container>
    );
};

export const renderIcon = (containerID: string) => {
    let labels: FixmeType[] = [];
    return (highchartRef: FixmeType) => {
        labels.forEach((label: FixmeType) => label.destroy());
        labels = [];
        highchartRef.series[0].points.forEach((point: FixmeType) => {
            const { options, pointWidth } = point;
            const { favicon, isSegment, className, regionalDomainsCount } = options;
            const column = document.getElementsByClassName(className)[0];
            if (!favicon || !column) {
                return;
            }
            const labelRef = highchartRef.renderer
                .label(
                    ...resolveHighChartLabelProps({
                        displayValue: ReactDOMServer.renderToString(
                            <IconWrapper
                                favicon={favicon}
                                columnClassName={className}
                                isSegment={isSegment}
                                pointWidth={pointWidth}
                                containerID={containerID}
                                subIconType={
                                    regionalDomainsCount > 0
                                        ? SubIconType.RegionalsWorld
                                        : isSegment
                                          ? SubIconType.ChartPie
                                          : SubIconType.None
                                }
                            />,
                        ),
                        x: 0,
                        y: 0,
                        useHTML: true,
                    }),
                )
                .add();
            labels.push(labelRef);
        });
    };
};
